import { DownOutlined, SearchOutlined } from '@ant-design/icons'
import { Button, Input, Popover, Select, Space, Typography } from 'antd'
import React, { useCallback, useEffect, useState } from 'react'
import { useIntl } from 'react-intl'

import styles from './styles.module.scss'

const { Text } = Typography

const SearchDropdown = ({
  onSearch,
  defaultValue,
  dropdownDefaultValue,
  onDropdownSearch,
  options,
  placeholder,
  autoFocus = true,
  ...props
}) => {
  const [searchIn, setSearchIn] = useState(() => dropdownDefaultValue || '')

  const { formatMessage } = useIntl()

  useEffect(() => {
    if (dropdownDefaultValue) {
      setSearchIn(dropdownDefaultValue)
    }
  }, [dropdownDefaultValue])

  const handleOpenChange = useCallback(
    (visible) => {
      if (!visible && dropdownDefaultValue !== searchIn && typeof onDropdownSearch === 'function') {
        onDropdownSearch(searchIn)
      }
    },
    [dropdownDefaultValue, onDropdownSearch, searchIn],
  )

  return (
    <Space.Compact className="w-100">
      <Input
        prefix={<SearchOutlined style={{ color: 'rgba(0,0,0,.25)' }} />}
        placeholder={placeholder || formatMessage({ id: 'input.placeholder.search' })}
        id="input-search"
        onChange={onSearch}
        allowClear
        autoComplete="off"
        autoFocus={autoFocus}
        defaultValue={defaultValue}
        {...props}
      />
      <Popover
        content={
          <Space>
            <Text>{formatMessage({ id: 'financeProduct.search_in' })}</Text>
            <Select
              style={{ width: 200 }}
              value={searchIn}
              onChange={setSearchIn}
              id="search_in"
              options={options}
            />
          </Space>
        }
        placement="bottomRight"
        trigger="click"
        onOpenChange={handleOpenChange}
        arrow
        styles={{ root: { width: 300 } }}
      >
        <Button color="default" variant="filled" rootClassName={styles.buttonDropdown}>
          <DownOutlined />
        </Button>
      </Popover>
    </Space.Compact>
  )
}

export default SearchDropdown
